import React from 'react';
const Company = () => {
  return (
    <div className='w-full h-screen bg-white py-16 px-4' id='company'>
        <h2 className='md:text-4xl sm:text-3xl font-bold text-indigo-600 pb-2'>About Us</h2>
        <p>
          Founded in 2020 by Makobe K, At Kabi Softwares, our mission is to bridge the digital divide and empower customers with seamless technology solutions. We started this company with the vision of providing comprehensive services to tackle computer-related challenges and deliver exceptional results.

          From computer repairs to software installations, our skilled technicians are dedicated to resolving issues promptly and efficiently. We understand the importance of smooth operations and offer reliable support to ensure your devices run at their best.
          
          In addition to our repair services, we excel in web development, creating engaging and user-friendly websites that leave a lasting impression. Our team of designers brings creativity and expertise to logo design, crafting unique and captivating visual identities for businesses.
          
          With a customer-centric approach, we prioritize delivering tailored solutions that meet your specific needs. Whether you're an individual, small business, or organization, we are committed to providing reliable technology services that enhance your digital presence.
          
          We strive for excellence in every aspect of our work, utilizing cutting-edge technologies and staying up-to-date with industry trends. Our commitment to continuous improvement ensures that we deliver the highest quality results to our valued customers.
          
          Join us in our mission to bridge the digital divide and harness the power of technology. Let us help you thrive in the digital world.
        </p>
        </div>
  );
};

export default Company;
